/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReferralRequest
 */
export interface UpdateReferralRequest {
    /**
     * New target discharge date for the referral
     * @type {Date}
     * @memberof UpdateReferralRequest
     */
    target_discharge_date: Date;
}

/**
 * Check if a given object implements the UpdateReferralRequest interface.
 */
export function instanceOfUpdateReferralRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "target_discharge_date" in value;

    return isInstance;
}

export function UpdateReferralRequestFromJSON(json: any): UpdateReferralRequest {
    return UpdateReferralRequestFromJSONTyped(json, false);
}

export function UpdateReferralRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferralRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'target_discharge_date': (new Date(json['target_discharge_date'])),
    };
}

export function UpdateReferralRequestToJSON(value?: UpdateReferralRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_discharge_date': (value.target_discharge_date.toISOString().substring(0,10)),
    };
}

